import styled from 'styled-components';
import PromoBanner from '../../../../components/campaign-banners/promo-banner';
import { layout } from '@prisjakt/ui-base';

export const StyledPromoBanner = styled(PromoBanner)`
  margin-left: ${layout.pageContent.gutter.rem};
  margin-right: ${layout.pageContent.gutter.rem};
`;
